export const advisorDone = state => state.options.advisorDone
export const defaultsSet = state => state.auth.defaultsSet
export const groupsDone = state => state.groups.done
export const groupsPending = state => state.groups.pending
export const reservationEventDone = state => state.options.reservationEventDone
export const reservationUserDone = state => state.options.reservationUserDone
export const user = state => state.auth.user
